import { DecimalPipe, NgFor } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TypographyComponent } from 'components';
import { AiSummaryLanguageTerm } from '@brand-lolly/app/social-media-influencer/modules/social-listening/models/social-listening-ai-summary.model';

@Component({
	standalone: true,
	selector: 'app-ai-summary-language-table',
	imports: [NgFor, DecimalPipe, TypographyComponent],
	templateUrl: './ai-summary-language-table.component.html',
	styleUrls: ['./ai-summary-language-table.component.scss']
})
export class AiSummaryLanguageTableComponent {
	@Input() terms: AiSummaryLanguageTerm[] = [];

	sourceLabel(source: AiSummaryLanguageTerm['source']): string {
		const map: Record<string, string> = {
			mentions: 'Mentions-led',
			reviews: 'Reviews-led',
			both: 'Both'
		};
		return map[source] ?? source;
	}
}
